const API_BASE_URL = 'https://evotekaro-backend.onrender.com'

export default API_BASE_URL